<div class="nc-loading">
    <!--1圆球排列-->
    <div [ngClass]="'ballArrangement_' + ncSize" *ngIf="ncType == 1">
        <div class="cs-loader">
            <div class="cs-loader-inner">
                <div style="--j:1"></div>
                <div style="--j:2"></div>
                <div style="--j:3"></div>
                <div style="--j:4"></div>
                <div style="--j:5"></div>
                <div style="--j:6"></div>
            </div>
        </div>
    </div>
    <!--2彩色跳动-->
    <div [ngClass]="'colorfulBounce_' + ncSize" *ngIf="ncType == 2">
        <div class="ball-row">
            <span class="ball" style="--i:1;--ii:0"></span>
            <span class="ball" style="--i:2;--ii:1"></span>
            <span class="ball" style="--i:3;--ii:2"></span>
            <span class="ball" style="--i:4;--ii:3"></span>
            <span class="ball" style="--i:5;--ii:4"></span>
        </div>
        <div class="shadow-row">
            <span class="shadow" style="--i:1;--ii:0"></span>
            <span class="shadow" style="--i:2;--ii:1"></span>
            <span class="shadow" style="--i:3;--ii:2"></span>
            <span class="shadow" style="--i:4;--ii:3"></span>
            <span class="shadow" style="--i:5;--ii:4"></span>
        </div>
    </div>
    <!--3旋转呼吸-->
    <div [ngClass]="'rotatingBreathing_' + ncSize" *ngIf="ncType == 3">
        <div class="box">
            <div class="circle"></div>
            <div class="circle"></div>
        </div>
    </div>
    <!--4多彩球体-->
    <div [ngClass]="'colorfulBall_' + ncSize" *ngIf="ncType == 4">
        <span style="--i:0;"></span>
        <span style="--i:1;"></span>
        <span style="--i:2;"></span>
        <span style="--i:3;"></span>
        <span style="--i:4;"></span>
        <span style="--i:5;"></span>
        <span style="--i:6;"></span>
    </div>
    <!--5爱心跳动-->
    <div [ngClass]="'heartBeating_' + ncSize" *ngIf="ncType == 5">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
    <!--6旋转齿轮-->
    <div [ngClass]="'gearbox_' + ncSize" *ngIf="ncType == 6">
        <div class="overlay"></div>
        <div class="gear one">
            <div class="gear-inner">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
        </div>
        <div class="gear two">
            <div class="gear-inner">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
        </div>
        <div class="gear three">
            <div class="gear-inner">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
        </div>
        <div class="gear four large">
            <div class="gear-inner">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
        </div>
    </div>
    <!--7弹跳小球-->
    <div [ngClass]="'bouncingBall_' + ncSize" *ngIf="ncType == 7"></div>
    <!--8滑块滑动-->
    <div [ngClass]="'sliderLoading_' + ncSize" *ngIf="ncType == 8"></div>
    <!--9容器填充-->
    <div [ngClass]="'containerFilling_' + ncSize" *ngIf="ncType == 9"></div>
    <!--10方块跳动-->
    <div [ngClass]="'blockJump_' + ncSize" *ngIf="ncType == 10">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
    <!--11spin-->
    <div [ngClass]="'spin11_' + ncSize" *ngIf="ncType == 11"></div>
    <!--12spin-->
    <div [ngClass]="'spin12_' + ncSize" *ngIf="ncType == 12"></div>
    <!--13spin-->
    <div [ngClass]="'spin13_' + ncSize" *ngIf="ncType == 13"></div>
    <!--14spin-->
    <div [ngClass]="'spin14_' + ncSize" *ngIf="ncType == 14"></div>
    <!--15spin-->
    <div [ngClass]="'spin15_' + ncSize" *ngIf="ncType == 15"></div>
    <!--16spin-->
    <div [ngClass]="'spin16_' + ncSize" *ngIf="ncType == 16"></div>
    <!--17spin-->
    <div [ngClass]="'spin17_' + ncSize" *ngIf="ncType == 17"></div>
    <!--18spin-->
    <div [ngClass]="'spin18_' + ncSize" *ngIf="ncType == 18"></div>
    <!--19spin-->
    <div [ngClass]="'spin19_' + ncSize" *ngIf="ncType == 19"></div>
    <!--20spin-->
    <div [ngClass]="'spin20_' + ncSize" *ngIf="ncType == 20"></div>
    <!--21spin-->
    <div [ngClass]="'spin21_' + ncSize" *ngIf="ncType == 21"></div>
    <!--22spin-->
    <div [ngClass]="'spin22_' + ncSize" *ngIf="ncType == 22"></div>
    <!--23spin-->
    <div [ngClass]="'spin23_' + ncSize" *ngIf="ncType == 23"></div>
    <!--24spin-->
    <div [ngClass]="'spin24_' + ncSize" *ngIf="ncType == 24"></div>
    <!--25spin-->
    <div [ngClass]="'spin25_' + ncSize" *ngIf="ncType == 25"></div>
    <!--26spin-->
    <div [ngClass]="'spin26_' + ncSize" *ngIf="ncType == 26"></div>
    <!--27spin-->
    <div [ngClass]="'spin27_' + ncSize" *ngIf="ncType == 27"></div>
    <!--28spin-->
    <div [ngClass]="'spin28_' + ncSize" *ngIf="ncType == 28"></div>
    <!--29spin-->
    <div [ngClass]="'spin29_' + ncSize" *ngIf="ncType == 29"></div>
    <!--30spin-->
    <div [ngClass]="'spin30_' + ncSize" *ngIf="ncType == 30"></div>
    <!--31spin-->
    <div [ngClass]="'spin31_' + ncSize" *ngIf="ncType == 31"></div>
    <!--32spin-->
    <div [ngClass]="'spin32_' + ncSize" *ngIf="ncType == 32"></div>
    <!--33spin-->
    <div [ngClass]="'spin33_' + ncSize" *ngIf="ncType == 33"></div>
    <!--34spin-->
    <div [ngClass]="'spin34_' + ncSize" *ngIf="ncType == 34"></div>
    <!--35spin-->
    <div [ngClass]="'spin35_' + ncSize" *ngIf="ncType == 35"></div>
    <!--36spin-->
    <div [ngClass]="'spin36_' + ncSize" *ngIf="ncType == 36"></div>
    <!--37spin-->
    <div [ngClass]="'spin37_' + ncSize" *ngIf="ncType == 37"></div>
    <!--38spin-->
    <div [ngClass]="'spin38_' + ncSize" *ngIf="ncType == 38"></div>
    <!--39spin-->
    <div [ngClass]="'spin39_' + ncSize" *ngIf="ncType == 39"></div>
    <!--40spin-->
    <div [ngClass]="'spin40_' + ncSize" *ngIf="ncType == 40"></div>
    <!--41hypnotic-->
    <div [ngClass]="'hypnotic41_' + ncSize" *ngIf="ncType == 41"></div>
    <!--42hypnotic-->
    <div [ngClass]="'hypnotic42_' + ncSize" *ngIf="ncType == 42"></div>
    <!--43hypnotic-->
    <div [ngClass]="'hypnotic43_' + ncSize" *ngIf="ncType == 43"></div>
    <!--44hypnotic-->
    <div [ngClass]="'hypnotic44_' + ncSize" *ngIf="ncType == 44"></div>
    <!--45hypnotic-->
    <div [ngClass]="'hypnotic45_' + ncSize" *ngIf="ncType == 45"></div>
    <!--46hypnotic-->
    <div [ngClass]="'hypnotic46_' + ncSize" *ngIf="ncType == 46"></div>
    <!--47hypnotic-->
    <div [ngClass]="'hypnotic47_' + ncSize" *ngIf="ncType == 47"></div>
    <!--48hypnotic-->
    <div [ngClass]="'hypnotic48_' + ncSize" *ngIf="ncType == 48"></div>
    <!--49hypnotic-->
    <div [ngClass]="'hypnotic49_' + ncSize" *ngIf="ncType == 49"></div>
    <!--50hypnotic-->
    <div [ngClass]="'hypnotic50_' + ncSize" *ngIf="ncType == 50"></div>
    <!--tips-->
    <div [ngStyle]="{'color': ncTipsColor, 'font-weight': ncTipsWeight}" [ngClass]="'ncTips_' + ncSize" *ngIf="ncTips">
        {{ncTips}}</div>
</div>